<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印远景"
      width="700px"
      top="2vh">
    <!--    50*25-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="90px">
        <el-form-item label="In">
          <el-input v-model="printInValue"/>
        </el-form-item>
        <el-form-item label="L">
          <el-input v-model="printLValue"/>
        </el-form-item>
        <el-form-item label="AC">
          <el-input v-model="printAC"/>
        </el-form-item>
        <el-form-item label="Hz">
          <el-input v-model="printHz"/>
        </el-form-item>
        <el-form-item label="Class">
          <el-input v-model="printClass"/>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="printQuantity" @input="codeChange">
            <!--            <el-button type="primary" slot="append" @click="codeChange">重新生成</el-button>-->
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-divider/>
    <div id="labelContent6a4">
      <div v-for="(productInfo,index) in productInfos" :key="index" id="printMaterialBoxLabel6a4">
        <div style="text-align: center;">
          <div style="width: 5px;height: 5px;float: left;">
            <img style="height: 30px;width: 30px;margin-top: -9px;" :src="logoSrc">
          </div>
          <div style="font-size: 12px;font-weight: bold;">{{titleName}}</div>
          <div style="font-size: 9px;font-weight: bold;margin-top: -5px;">
            {{printType}}
          </div>
          <div style="display: flex;text-align: center;margin-top: -5px;">
            <div style="font-size: 10px;font-weight: bold;">{{printIn}}{{printInValue}}</div>
            <div style="font-size: 10px;font-weight: bold;margin-left: 50px;">{{printL}}{{printLValue}}</div>
          </div>
          <div style="display: flex;margin-top: -5px;">
            <div style="font-size: 10px;font-weight: bold;">{{printAC}}</div>
            <div style="font-size: 10px;font-weight: bold;margin-left: 8px;">{{printHz}}</div>
            <div style="font-size: 10px;font-weight: bold;margin-left: 10px;">{{printClass}}</div>
          </div>
          <div style="display: flex;text-align: center;margin-top: -5px;">
            <div style="font-size: 9px;font-weight: bold;">{{printInput}}</div>
            <div style="font-size: 9px;font-weight: bold;margin-left: 5px;">
              {{printOutput}}
            </div>
          </div>
          <div style="text-align: center;margin-top: -5px;">
            <img style="width:100%;height:10px;" :id="(() => 'barCode6a4_'+productInfo.pkid)()">
          </div>
          <div style="font-size: 10px;font-weight: bold;margin-top: -7px;">{{productInfo.text}}</div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        titleName: "AC REACTOR",
        printType: "",
        printL: "L:",
        printLValue: "",
        printIn: "In:",
        printInValue: "",
        printAC: "AC:380V",
        printHz: "50-60Hz",
        printClass: "Class:F",
        printInput: "InputL1.1/L2.1/L3.1",
        printOutput: "L1.2/L2.2/L3.2Output",
        printQuantity: 0,
        printFirstNum: "0",
        productInfo: {},
        productInfos: [],
        logoSrc: "",
        barCodeText: "",
        printOption: {
          id: "labelContent6a4",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo, firstNum) {
        this.logoSrc = "../../../../img/se/logo1.png";
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.printType = this.productInfo.specification;
        if (this.printType) {
          let params = this.printType.split("-");
          if (params.length >= 3) {
            this.printInValue = parseInt(params[1]) + "A";
            this.printLValue = parseFloat(params[2].replace("M", ".")) + "mH";
          }
        }
        this.printFirstNum = firstNum;
        this.printQuantity = this.productInfo.quantity;
        this.printDate = this.productInfo.planStartTime;
        this.barCodeText = "HKX" + moment(new Date(this.printDate)).format("YYMM");
        this.setBarcode();
      },

      getData() {
        this.$http.get("basic", "taskDispatchBills/getPrintNo").then((res) => {
          if (res.success) {
            if (res.data) {
              this.printFirstNum = res.data;
            } else {
              this.printFirstNum = 0;
            }
          }
        });
      },

      setBarcode() {
        this.productInfos = [];
        for (var i = 0; i < parseInt(this.printQuantity); i++) {
          let text = this.barCodeText.substring(0, 7) + (parseInt(this.printFirstNum) + i).toString().padStart(4, "0");
          let info = {
            pkid: text,
            text: text,
          };
          this.productInfos.push(info);
          this.$nextTick(() => {
            document.getElementById("barCode6a4_" + text).innerHTML = "";
            this.bindBarCode(text, text);
          });
        }
      },

      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode6a4_" + id), row, {
          text: text,
          fontSize: 14,
          width: 4,
          height: 8,
          margin: 0,
          displayValue: false,
        });
      },
      codeChange() {
        this.getData();
        this.setBarcode();
      },

      print() {
        this.$http.get("basic", `taskDispatchBills/updatePrintYj/${this.productInfo.pkid}/${this.printQuantity}`)
            .then((res) => {
              if (res.success) {
              this.printFirstNum = parseInt(this.printFirstNum) + parseInt(this.printQuantity);
              this.setBarcode();
              }
            });
      },
    },
  };
</script>
<style lang="scss" scoped>
#printMaterialBoxLabel6a4 {
  width: 48mm;
  height: 23mm;
  margin: 0 auto;
  //margin-top: 1mm;
  page-break-before: always;
  //font-size: 10px;
  display: flex;
  align-items: center;
}

@media print {
  .prevent-page-break-inside {
    page-break-inside: avoid;
  }

  #printMaterialBoxLabel6a4 {
    margin: 0;
  }

  @page {
    padding: 1mm;
  }
}
</style>
